import * as R from 'ramda'

/**
 * @return string
 */
export const packageCodeToName = (code) => {
  if (code.includes('_light_')) {
    return 'Light'
  }
  if (code.includes('_air_')) {
    return 'Air'
  }
  if (code.includes('_starter_')) {
    return 'Starter'
  }
  if (code.includes('_basic_')) {
    return 'Basic'
  }
  if (code.includes('_medium_')) {
    return 'Medium'
  }
  if (code.includes('_plus_')) {
    return 'Plus'
  }
  if (code.includes('_pro_')) {
    return 'Pro'
  }
  if (code.includes('_premium_')) {
    return 'Premium'
  }
  if (code.includes('_exclusive_')) {
    return 'Exclusive'
  }
  if (code.includes('_diamond_')) {
    return 'Diamond'
  }
  if (code.includes('_smart_ultima_')) {
    return 'Smart Ultima'
  }
  if (code.includes('_ultima_')) {
    return 'Ultima'
  }
  return code
}

export const formatCoin4 = (val) => {
  return +val.toFixed(4)
}

/**
 *
 */
export const findUpAttr = (el, attrName) => {
  while (el.parentNode) {
    el = el.parentNode
    const attr = R.path(['attributes', attrName], el)
    if (attr) return attr.value
  }
  return null
}

export const scale = (current, max) => {
  let result = 0;
  if (max > 0) {
    result = (current / max) * 100;
  }
  if (result < 0) {
    return 0;
  }
  if (result > 100) {
    return 100;
  }
  return result;
};
